module.exports = "/_next/static/images/social proof-8b59b7caa17f04f259beb40eca348a87.png";